import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import { useInputValue } from '../../hooks/useInputValue'
import Switch from 'react-switch'
import Select from 'react-select'
import { Growl } from 'primereact/growl'

import './styles.scss'

export const LaboratoriesForm = ({
  item,
  isLoading,
  podsList,
  podsListToEdit,
  onSubmit,
  cancelLink,
}) => {
  const [checked, setChecked] = useState(item !== null ? (item.status ? true : false) : false)
  const [selectedFile, setSelectedFile] = useState(null)
  const [selectedTopology, setselectedTopology] = useState(null)
  const [podSelected, setPodSelected] = useState([])
  const [resourceName, setResourceName] = useState('')
  const [topologyName, setTopologyName] = useState('')
  const [podModified, setPodModified] = useState(false)
  const growlRef = useRef(null)

  const UploadFile = (e) => {
    const file = e[0]
    if (file.type !== 'application/pdf') {
      showGrowl('error', 'Error', 'El archivo debe ser un PDF')
      return
    }
    setResourceName(file.name)
    setSelectedFile(e)
  }

  const UploadTopology = (e) => {
    const file = e[0]
    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif']
    if (!validImageTypes.includes(file.type)) {
      showGrowl('error', 'Error', 'El archivo debe ser una imagen (JPG, PNG, GIF)')
      return
    }
    setTopologyName(file.name)
    setselectedTopology(e)
  }

  const sw = () => {
    const handleChange = (nextChecked) => {
      setChecked(nextChecked)
    }
    return (
      <div className="swcomponent">
        <Switch onChange={handleChange} checked={checked} className="react-switch" />
      </div>
    )
  }

  const { ...pod } = useInputValue(
    {
      value: item ? item.name : '',
      name: 'Pod',
      disabled: isLoading,
    },
    false
  )

  const { ...name } = useInputValue(
    {
      value: item ? item.name : '',
      name: 'Name',
      type: 'text',
      required: true,
      disabled: isLoading,
    },
    false
  )

  const { ...text } = useInputValue(
    {
      value: item ? item.text : '',
      type: 'text',
      name: 'Text',
      disabled: isLoading,
    },
    false
  )

  const { ...description } = useInputValue(
    {
      value: item ? item.description : '',
      name: 'Descripción',
      type: 'text',
      disabled: isLoading,
    },
    false
  )

  const showGrowl = (severity, summary, detail) => {
    growlRef.current.show({
      severity,
      summary,
      detail,
    })
  }

  const handleCourseChange = (selectedOptions) => {
    setPodSelected(selectedOptions)
    setPodModified(true)
  }

  const hadleSubmit = (e) => {
    e.preventDefault()

    let pods = []

    if (!item && selectedFile === null) {
      showGrowl('error', 'error', 'Debe seleccionar una guia para el laboratorio')
      return
    }

    if (!item && selectedTopology === null) {
      showGrowl('error', 'error', 'Debe seleccionar una topologiapara el laboratorio')
      return
    }

    if (podModified) {
      pods = podSelected.length > 0 ? podSelected.map((vselec) => vselec.value) : []
    } else {
      pods = podsListToEdit.map((course) => course.value)
    }

    const formData = new FormData()
    formData.append('name', name.value)

    // Update file handling to include file type
    if (selectedFile != null) {
      const file = selectedFile[0]
      formData.append('file', file)
      // Add file type to differentiate in backend
      formData.append('fileType', 'file')
    }

    if (selectedTopology != null) {
      const topology = selectedTopology[0]
      formData.append('topology', topology)
      // Add topology type to differentiate in backend
      formData.append('topologyType', 'topology')
    }

    formData.append('text', text.value)
    formData.append('description', description.value)
    formData.append('pods', JSON.stringify(pods))
    formData.append('status', checked ? 1 : 0)
    onSubmit(formData)
  }

  return (
    <div className="form-container">
      <Growl ref={growlRef}></Growl>
      <form disabled={isLoading} onSubmit={hadleSubmit}>
        <div className="form-group">
          <label htmlFor="name-input">Nombre {name.required ? '*' : ''}</label>
          <InputText maxLength={30} id="name-input" {...name} />
        </div>

        <div className="form-group">
          <label htmlFor="name-input">Introducción{description.required ? '*' : ''}</label>
          <InputTextarea maxLength={100} id="text-input" {...description} />
        </div>

        <div className="form-group">
          <label htmlFor="description-input">Notas{text.required ? '*' : ''}</label>
          <InputTextarea maxLength={50} id="description-input" {...text} />
        </div>

        <div className="form-group">
          <label htmlFor="description-input">Guías de laboratorio</label>
          <label className="file">
            <input
              type="file"
              name="file"
              id="file"
              className="file"
              onChange={(e) => UploadFile(e.target.files)}
            />
            <span className="file-custom">
              {' '}
              {resourceName ? resourceName : 'Seleccionar archivo'}
            </span>
          </label>
        </div>

        <div className="form-group">
          <label htmlFor="description-input">Topología</label>

          <label className="file">
            <input
              type="file"
              name="topology"
              id="topology"
              className="file"
              onChange={(e) => UploadTopology(e.target.files)}
            />
            <span className="file-custom">
              {' '}
              {topologyName ? topologyName : 'Seleccionar archivo'}
            </span>
          </label>
        </div>

        <div className="form-group">
          <label htmlFor="type-input">Pods {pod.required ? '*' : ''}</label>
          <Select
            defaultValue={podsListToEdit}
            isMulti
            name="pod"
            options={podsList}
            className="basic-multi-select"
            id="pod"
            classNamePrefix="select"
            onChange={handleCourseChange}
          />
        </div>

        {/*         <div className="form-group">
          <label htmlFor="duration-input">Duración {duration.required ? '*' : ''}</label>
          <InputText id="duration-input" {...duration} />
        </div> */}

        <div className="form-group">
          <label htmlFor="estado-input">Estado </label>
          {sw()}
        </div>
        <div className="button-group">
          <Button
            label={isLoading ? 'Guardando...' : 'Guardar'}
            disabled={isLoading}
            type="submit"
            className="button primary"
          />
          <Link to={cancelLink} className="button secondary">
            Cancelar
          </Link>
        </div>
      </form>
    </div>
  )
}

LaboratoriesForm.propTypes = {
  item: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cancelLink: PropTypes.string.isRequired,
}
